import { useEffect } from 'preact/hooks';
import { WebBubble } from './components/web/WebBubble';
import { WebChatPanel } from './components/web/WebChatPanel';
import { DigitalRoot } from './components/digital/DigitalRoot';
import { config, opened, ready, openDigitalWelcome } from './store/widget-store';
import { useI18n } from './hooks/use-i18n';

export function App() {
  // Locale is initialised earlier in main.tsx (initLocale()) so the very first
  // render already paints in the correct language — avoids brief default-zh
  // flash when the user has previously chosen another locale.
  const { dir, locale } = useI18n();

  // 当 config ready 后,根据 defaultWindow 决定初始展开状态。按类型分流:
  //  - web 线维持原行为(opened=true)
  //  - digital 线走视图态:max → 进欢迎屏(openDigitalWelcome 同步置 opened)
  useEffect(() => {
    if (!ready.value || !config.value) return;
    if (config.value.type !== 'digital') {
      if (config.value.defaultWindow === 'max') opened.value = true;
      return;
    }
    if (config.value.defaultWindow === 'max') openDigitalWelcome();
  }, [ready.value, config.value]);

  const cfg = config.value;
  const isWeb = cfg?.type === 'web';

  return (
    <div class="dcs-root" dir={dir} lang={locale}>
      {isWeb ? (
        <>
          <WebBubble />
          <WebChatPanel />
        </>
      ) : (
        <DigitalRoot />
      )}
    </div>
  );
}
